import React, { useState, useEffect } from "react";
import { Row, InputGroup, Button, Table } from "react-bootstrap";
import { CCol, CFormLabel } from "@coreui/react";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import { number_format } from "../../../helpers/utility";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import { getPlData } from "../../../redux/slices/ReportSlice";

const ProfitLossIndex = () => {
    const dispatch = useDispatch();
    // const [formData, setFormData] = useState(INIT_FORM_DATA);

    const LIST_PARAMS = {
        filter: {
            fromdate: format(new Date(new Date().setFullYear(new Date().getFullYear() - 1)), "yyyy-MM-dd"),
            todate: format(new Date(), "yyyy-MM-dd")
        }
    };
    const [params, setParams] = useState(LIST_PARAMS);
    const [data, setData] = useState([]);

    useEffect(()=> {
        getComponentData();
    }, [params]);

    const getComponentData = async() => {
        try {
            const { payload } = await dispatch(getPlData({ inputData: params }));
            // console.log(payload);
            
            setData(payload);
            // setTotalPage(Math.ceil(payload?.count/rowsPerPage)); 
        } catch (err) {
            // toastMessage("error", "Failed to fetch data");
        } finally {
            // setIsLoading(false); // Stop loader
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setParams((prevParams) => ({
            ...prevParams,
            filter: {
                ...prevParams.filter,
                [name]: name === "fromdate"
                    ? format(new Date(value), "yyyy-MM-dd")
                    : name === "todate"
                        ? format(new Date(value), "yyyy-MM-dd")
                        : value
            }
        }));
    };

    const handleAmountFormat = (amount) => {
        return number_format(amount,2);
    };

    return(
        <PageWrapper pageName={"Profit & Loss"}>
            <Row className="row-xs mb-4">      
                <CCol md={3}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="invoice_Date">From Date</CFormLabel>
                    <InputGroup className="input-group reactdate-pic">
                        <InputGroup.Text className="input-group-text">
                            <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                        </InputGroup.Text>
                        <DatePicker
                            className="form-control"
                            name="fromdate"
                            id="fromdate"
                            selected={params.filter.fromdate ? new Date(params.filter.fromdate) : null} // Convert to Date object
                            onChange={(date) => {
                                const event = {
                                    target: {
                                        name: "fromdate",
                                        value: date,
                                    },
                                };
                                handleInputChange(event); // Simulate an event for compatibility
                            }}
                            dateFormat="yyyy-MM-dd" // Match the desired format
                            // isClearable // Optional: Allow clearing the date
                        />
                    </InputGroup>
                </CCol>
                <CCol md={3}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="todate">To Date</CFormLabel>
                    <InputGroup className="input-group reactdate-pic">
                        <InputGroup.Text className="input-group-text">
                            <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
                        </InputGroup.Text>
                        <DatePicker
                            className="form-control"
                            name="todate"
                            id="todate"
                            selected={params.filter.todate ? new Date(params.filter.todate) : null} // Convert to Date object
                            onChange={(date) => {
                                const event = {
                                    target: {
                                        name: "todate",
                                        value: date,
                                    },
                                };
                                handleInputChange(event); // Simulate an event for compatibility
                            }}
                            dateFormat="yyyy-MM-dd" // Match the desired format
                            // isClearable // Optional: Allow clearing the date
                        />
                    </InputGroup>
                </CCol>
                {/* <CCol md={3} style={{ display: "flex", alignItems: "center", justifyContent: "left", paddingTop: "28px" }}>
                    <Row className="btn-animation">
                        <Button
                            variant=""
                            type="button"
                            className={`btn btn-sm btn-primary ms-2`}
                            // onClick={() => {searchIncomeStatement()}}
                        >
                            Get Data
                        </Button>
                    </Row>
                </CCol> */}
            </Row>

            <Table className="text-nowrap mb-0">
                <thead>
                    <tr className="border-bottom border-top">
                        <th className="w-40">Particulars</th>
                        <th className="w-10 text-right">Amount</th>
                        <th className="w-40">Particulars</th>
                        <th className="w-10 text-right">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="cursor-pointer">
                        <td className="pb-0">Cost of Revenue</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.cost_of_rev)}</td>
                        <td className="pb-0">Revenue</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.revenue)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pt-10 font-weight-bold">Gross Profit C/F</td>
                        <td className="pb-0 text-right font-weight-bold">{handleAmountFormat(data.gp)}</td>
                        <td className="pb-0"></td>
                        <td className="pb-0 text-right"></td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className=""></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(data.revenue)}</td>
                        <td className=""></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(data.revenue)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pb-0"></td>
                        <td className="pb-0 text-right"></td>
                        <td className="pb-0">Gross Profit B/F</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.gp)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pb-0">Indirect Expenses</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.other_expence)}</td>
                        <td className="pb-0">Indirect Incomes</td>
                        <td className="pb-0 text-right">{handleAmountFormat(data.other_Income)}</td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className="pt-10 font-weight-bold">Net Profit</td>
                        <td className="pb-0 text-right font-weight-bold">{handleAmountFormat(data.np)}</td>
                        <td className="pb-0"></td>
                        <td className="pb-0 text-right"></td>
                    </tr>
                    <tr className="cursor-pointer">
                        <td className=""></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(0)}</td>
                        <td className=""></td>
                        <td className=" text-right border-top border-bottom">{handleAmountFormat(0)}</td>
                    </tr>
                </tbody>
            </Table>
        </PageWrapper>
    );
};

export default ProfitLossIndex;